var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.73943,
    height: 18.5842,
    rx: 1.86972,
    transform: "matrix(0.783826 -0.62098 0.644005 0.765021 13.4548 16.04)",
    fill: "#2F406E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1426,
    cy: 11.0671,
    rx: 11.1426,
    ry: 10.8095,
    fill: "#2F406E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9324,
    cy: 10.8644,
    rx: 8.82998,
    ry: 8.56606,
    fill: "#96AFD6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9318,
    cy: 10.8621,
    rx: 7.98903,
    ry: 7.75024,
    fill: "#A6BBDC"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9318,
    cy: 10.8621,
    rx: 7.98903,
    ry: 7.75024,
    fill: "#91C9E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.557 8.00903C16.7484 9.9126 17.4492 14.1276 12.1932 16.5751",
    stroke: "#C1D9FF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4548 5.35718L14.9264 7.19276",
    stroke: "#C1D9FF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.94b89128ab92ab1c3310ec9e1e05c0f1.svg";
export { ForwardRef as ReactComponent };